import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductConfig, CommonTool, ProductLink } from '../config/product.config';
import './operations-index.component.css';

@Component({
  selector: 'app-operations-index',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './operations-index.component.html',
  styleUrls: ['./operations-index.component.css']
})
export class OperationsIndexComponent {
  @Input() currentProduct!: ProductConfig;
  @Input() allProducts: ProductConfig[] = [];
  @Input() commonTools: CommonTool[] = [];
}
